import React, {useState, useEffect} from 'react';
import {Context} from '../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import i18n from '../../i18n';
import {useTranslation} from 'react-i18next';
import Tabela from '../../components/Agendamentos/Agenda';
import TableChartIcon from '@mui/icons-material/TableChart';
import Calendario from '../../components/Agendamentos/Calendario';
import Table from '../../components/Catalogo/Table';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DrawerFilter from '../../components/Catalogo/DrawerFilter';
import NovoAgendamento from '../../components/Agendamentos/NovoAgendamento';
import ItemCatalogo from '../../components/Catalogo/ItemCatalogo/Sobre';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import Sobre from '../../components/Catalogo/ItemCatalogo/Sobre';
import Stock from '../../components/Catalogo/ItemCatalogo/Stock';
import {getInfoArtigoPopup, getMarcas, getModelos, getVersoes, getTipos, getNacionaisInternacionais, getCategoriasArtigos} from '../../pages/requests';
import {useContext} from 'react';

function Catalogo(color) {
    //const history = useHistory();
    const {t} = useTranslation();
    const [openTab, setOpenTab] = React.useState(1);
    // const [showForm, setShowForm] = useState(false);
    const [hideTable, setHideTable] = useState(false);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [codigoItem, setCodigoItem] = useState('');
    const [nomeItem, setNomeItem] = useState('');
    const [dadosItem, setDadosItem] = useState('');
    const {path, setPath} = useContext(Context);

    //Filtros tabela
    const [filtroReferencia, setFiltroReferencia] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState([]);
    const [filtroMarca, setFiltroMarca] = useState([]);
    const [filtroNacionalInternacional, setFiltroNacionalInternacional] = useState([]);
    const [filtroTipo, setFiltroTipo] = useState([]);
    const [filtroModelo, setFiltroModelo] = useState([]);
    const [filtroVersao, setFiltroVersao] = useState([]);
    const [filtroCStock, setFiltroCStock] = useState([]);

    // OPTIONS TABELA

    const [optionsCategorias, setOptionsCategorias] = useState([]);
    const [optionsMarca, setOptionsMarca] = useState([]);
    const [optionsNacionaisInternacionais, setOptionsNacionaisInternacionais] = useState([]);
    const [optionsTipo, setOptionsTipo] = useState([]);
    const [optionsModelo, setOptionsModelo] = useState([]);
    const [optionsVersao, setOptionsVersao] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleRowClick = dados => {
        setItemSelecionado(dados);
    };

    const [totalProdutos, setTotalProdutos] = useState(0);
    const ITEMS_PER_PAGE = 15;
    const [currentPage, setCurrentPage] = useState(1);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        if (itemSelecionado != null) {
            setPath(t('sobre') + ' ' + itemSelecionado.id + '-' + itemSelecionado.nome);
        } else {
            setPath('');
        }
    }, [path, itemSelecionado]);

    useEffect(() => {
        if (codigoItem != '') {
            const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
            const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
            getInfoArtigoPopup(codigoItem, indexOfFirstItem, indexOfLastItem - 1, lang).then(res => {
                setDadosItem(res.data);
                setTotalProdutos(res.data.totalprodutos);
            });
        }
    }, [codigoItem]);

    useEffect(() => {
        setLoading(true);
        var promises = [];

        promises.push(
            getMarcas(lang).then(res => {
                if (res.data.success) {
                    setOptionsMarca(res.data.marcas);
                }
            }),
        );

        promises.push(
            getCategoriasArtigos(lang).then(res => {
                if (res.data.success) {
                    setOptionsCategorias(res.data.categorias);
                }
            }),
        );

        promises.push(
            getNacionaisInternacionais(lang).then(res => {
                if (res.data.success) {
                    setOptionsNacionaisInternacionais(res.data.nacionaisInternacionais);
                }
            }),
        );

        promises.push(
            getTipos(lang).then(res => {
                if (res.data.success) {
                    setOptionsTipo(res.data.tipos);
                }
            }),
        );

        promises.push(
            getModelos(lang).then(res => {
                if (res.data.success) {
                    setOptionsModelo(res.data.modelos);
                }
            }),
        );
        promises.push(
            getVersoes(lang).then(res => {
                if (res.data.success) {
                    setOptionsVersao(res.data.versoes);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <>
            <div className="border-b mb-5 border-gray-200 dark:border-gray-600">
                <div
                    className="flex flex-wrap items-center justify-between -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
                    role="tablist"
                    id="myTab"
                    data-tabs-toggle="#myTabContent">
                    <div className="flex space-x-2">
                        {hideTable && (
                            <div>
                                <button
                                    aria-controls="agenda"
                                    id="agenda-tab"
                                    type="button"
                                    data-toggle="tab"
                                    href="#link1"
                                    role="tablist"
                                    aria-current="page"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 1
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(1);
                                    }}>
                                    <InfoOutlinedIcon className="mr-2" />
                                    {t('sobre')}
                                </button>

                                <button
                                    aria-controls="calendario"
                                    id="calendario-tab"
                                    data-toggle="tab"
                                    href="#link2"
                                    role="tablist"
                                    type="button"
                                    // className="inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group"
                                    className={
                                        'inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group' +
                                        (openTab === 2
                                            ? ' justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group'
                                            : ' border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300')
                                    }
                                    onClick={e => {
                                        e.preventDefault();
                                        setOpenTab(2);
                                    }}>
                                    <InventoryOutlinedIcon className="mr-2" />
                                    {t('stockPrecos')}
                                </button>
                            </div>
                        )}
                    </div>

                    <DrawerFilter
                        hideTable={hideTable}
                        setHideTable={setHideTable}
                        filtroReferencia={filtroReferencia}
                        setFiltroReferencia={setFiltroReferencia}
                        filtroCategoria={filtroCategoria}
                        setFiltroCategoria={setFiltroCategoria}
                        filtroMarca={filtroMarca}
                        setFiltroMarca={setFiltroMarca}
                        setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                        filtroNacionalInternacional={filtroNacionalInternacional}
                        filtroTipo={filtroTipo}
                        setFiltroTipo={setFiltroTipo}
                        filtroModelo={filtroModelo}
                        setFiltroModelo={setFiltroModelo}
                        filtroVersao={filtroVersao}
                        setFiltroVersao={setFiltroVersao}
                        filtroCStock={filtroCStock}
                        setFiltroCStock={setFiltroCStock}
                        optionsCategorias={optionsCategorias}
                        optionsMarca={optionsMarca}
                        optionsModelo={optionsModelo}
                        optionsNacionaisInternacionais={optionsNacionaisInternacionais}
                        optionsTipo={optionsTipo}
                        optionsVersao={optionsVersao}
                    />
                </div>
            </div>

            {!hideTable ? (
                <div>
                    <Table
                        setHideTable={setHideTable}
                        onRowClick={handleRowClick}
                        setCodigoItem={setCodigoItem}
                        setNomeItem={setNomeItem}
                        filtroReferencia={filtroReferencia}
                        setFiltroReferencia={setFiltroReferencia}
                        filtroCategoria={filtroCategoria}
                        setFiltroCategoria={setFiltroCategoria}
                        filtroMarca={filtroMarca}
                        setFiltroMarca={setFiltroMarca}
                        setFiltroNacionalInternacional={setFiltroNacionalInternacional}
                        filtroNacionalInternacional={filtroNacionalInternacional}
                        filtroTipo={filtroTipo}
                        setFiltroTipo={setFiltroTipo}
                        filtroModelo={filtroModelo}
                        setFiltroModelo={setFiltroModelo}
                        filtroVersao={filtroVersao}
                        setFiltroVersao={setFiltroVersao}
                        filtroCStock={filtroCStock}
                        setFiltroCStock={setFiltroCStock}
                        optionsCategorias={optionsCategorias}
                        optionsMarca={optionsMarca}
                        optionsModelo={optionsModelo}
                        optionsNacionaisInternacionais={optionsNacionaisInternacionais}
                        optionsTipo={optionsTipo}
                        optionsVersao={optionsVersao}
                        setLoading={setLoading}
                        loading={loading}
                    />
                </div>
            ) : (
                <div id="myTabContent">
                    {openTab === 1 && (
                        <Sobre hideTable={hideTable} setHideTable={setHideTable} onRowClick={handleRowClick} Item={itemSelecionado} dadosItem={dadosItem} codigoItem={codigoItem} nomeItem={nomeItem} />
                    )}

                    {openTab === 2 && (
                        <Stock
                            hideTable={hideTable}
                            setHideTable={setHideTable}
                            onRowClick={handleRowClick}
                            Item={itemSelecionado}
                            dadosItem={dadosItem}
                            codigoItem={codigoItem}
                            nomeItem={nomeItem}
                            currentPage={currentPage}
                            totalProdutos={totalProdutos}
                            ITEMS_PER_PAGE={ITEMS_PER_PAGE}
                            setCurrentPage={setCurrentPage}
                        />
                    )}
                </div>
            )}
        </>
        // )}
    );
}

export default Catalogo;
